import type { ConfirmedChange, ConfirmStatus } from '../domain/confirm-email-change.model';
import type { ConfirmEmailChangeError } from '../domain/confirm-email-change-error';

/**
 * Redux state for the confirmation page. No draft: the page has no input; the
 * token is not here either, since the URL stays its single source of truth (the page
 * reads it and passes it in the signal action's payload).
 */
export interface ConfirmEmailChangeState {
  status: ConfirmStatus;
  confirmed: ConfirmedChange | null;
  error: ConfirmEmailChangeError | null;
}

export const initialState: ConfirmEmailChangeState = {
  status: 'idle',
  confirmed: null,
  error: null,
};
